import React, { useEffect } from "react";
import Hero from "@/components/Hero";
import ShowcaseStrip from "@/components/ShowcaseStrip";
import DamageConfigurator from "@/components/DamageConfigurator";
import LeasingCheck from "@/components/LeasingCheck";
import Services from "@/components/Services";
import Benefits from "@/components/Benefits";
import About from "@/components/About";
import Process from "@/components/Process";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import { motion } from "framer-motion";
import { MessageCircle, ArrowRight } from "lucide-react";
import { buildWhatsAppLink } from "@/lib/constants";

const FinalCTA = () => (
  <section data-testid="final-cta-section" className="py-24 lg:py-32 bg-white">
    <div className="max-w-6xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="relative overflow-hidden rounded-[2.5rem] bg-gradient-to-br from-[#0F172A] via-[#0F4651] to-[#1FA3B5] p-10 lg:p-20 text-white"
      >
        <div className="absolute -top-20 -right-20 w-80 h-80 bg-[#1FA3B5]/30 rounded-full blur-3xl" />
        <div className="absolute -bottom-20 -left-20 w-96 h-96 bg-[#1FA3B5]/20 rounded-full blur-3xl" />

        <div className="relative max-w-3xl">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#7FE0EC] mb-5">Bereit für die entspannte Rückgabe?</p>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05]">
            Sparen Sie sich teure Nachzahlungen.
            <br />
            <span className="text-[#7FE0EC]">Sprechen Sie mit AutoCoach.</span>
          </h2>
          <p className="mt-7 text-lg text-white/80 leading-relaxed max-w-2xl">
            Ein kurzer WhatsApp-Text reicht – wir melden uns, prüfen Ihre Fotos und geben Ihnen einen
            ehrlichen Festpreis für die optimale Vorbereitung Ihres Fahrzeugs.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href={buildWhatsAppLink()}
              target="_blank"
              rel="noreferrer"
              data-testid="final-cta-whatsapp"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white rounded-full px-8 py-4 font-semibold hover:bg-[#1DAE54] hover:-translate-y-0.5 transition-all shadow-xl shadow-black/20"
            >
              <MessageCircle className="w-5 h-5" /> WhatsApp starten
            </a>
            <a
              href="#spar-check"
              data-testid="final-cta-check"
              className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur text-white border border-white/20 rounded-full px-8 py-4 font-semibold hover:bg-white/20 transition-all"
            >
              60-Sek. Spar-Check <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);

const Home = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main data-testid="home-page">
      <Hero />
      <ShowcaseStrip />
      <LeasingCheck />
      <DamageConfigurator />
      <Services />
      <Benefits />
      <About />
      <Process />
      <Testimonials />
      <FAQ />
      <FinalCTA />
      <Contact />
    </main>
  );
};

export default Home;
